
import { createCtx } from 'utils/context';
export const [useSnackMessage, Provider] = createCtx();
